import { Pipe } from "@angular/core";
import { PermissionService } from "src/app/_services/permission.service";

@Pipe({
  name: "permissions",
})
export class PermissionsPipe {
  constructor(private permissionService: PermissionService) {}
  transform(permissions: string[], logicalOp = "AND") {
    return this.permissionService.checkPermission(permissions, logicalOp);
  }
}
